import { serverUrl } from "config/envConfig";
import { deleteAllCookies, isLoggedIn } from "../utils/helperFunctions";
import { kioskApi } from "./apiGodFile";
import apiList from "./apiList";
import { DATA_REFERENCE, KIOSK_ID_KEY } from "utils/Constants";

const addKioskIdToCmsUrl = (url) => {
  if (!url || !url.includes("/cms/api/")) {
    return url;
  }

  if (url.includes("kioskId=")) {
    return url;
  }

  let kioskId = "";
  try {
    const savedConfig = JSON.parse(localStorage.getItem(DATA_REFERENCE)) || {};
    kioskId = savedConfig[KIOSK_ID_KEY] || "";
  } catch (e) {}

  if (!kioskId) {
    return url;
  }

  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}kioskId=${kioskId}`;
};

const isEmptyCmsResponse = (data) => {
  if (data == null) return true;
  if (Array.isArray(data)) return data.length === 0;
  if (typeof data === "object") return Object.keys(data).length === 0;
  return false;
};

export const callApi = {
  get: async (url, data, headers, counter = 0, baseUrl = null) => {
    const requestUrl = addKioskIdToCmsUrl(url);
    const cmsCallWithKioskId = requestUrl !== url && url?.includes("/cms/api/");

    const makeRequest = (targetUrl) =>
      kioskApi({
        method: "GET",
        url: `${targetUrl}`,
        params: data,
        headers: {
          ...headers,
        },
        baseURL: baseUrl === null ? serverUrl : baseUrl,
      });

    try {
      let response = await makeRequest(requestUrl);

      if (cmsCallWithKioskId && isEmptyCmsResponse(response?.data)) {
        response = await makeRequest(url);
      }

      return response.data;
    } catch (error) {
      if (cmsCallWithKioskId && error?.response?.status === 404) {
        try {
          const fallbackResponse = await makeRequest(url);
          return fallbackResponse.data;
        } catch (fallbackError) {
          error = fallbackError;
        }
      }

      let apiResponse = await handleResponse(
        error.response,
        callApi.get,
        url,
        data,
        headers,
        counter
      );

      return apiResponse;
    }
  },
  post: async (url, data, headers, counter = 0, timeout) => {
    try {
      const response = await kioskApi({
        method: "POST",
        url: `${url}`,
        data,
        headers: {
          ...headers,
        },
        ...(timeout && { timeout }),
      });

      return response.data;
    } catch (error) {
      let apiResponse = await handleResponse(
        error.response,
        (...args) => callApi.post(...args, timeout),
        url,
        data,
        headers,
        counter
      );

      return apiResponse;
    }
  },
  patch: async (url, data, headers, counter = 0) => {
    try {
      const response = await kioskApi({
        method: "PATCH",
        url: `${url}`,
        data,
        headers: {
          ...headers,
        },
      });

      return response.data;
    } catch (error) {
      let apiResponse = await handleResponse(
        error.response,
        callApi.patch,
        url,
        data,
        headers,
        counter
      );

      return apiResponse;
    }
  },
  put: async (url, data, headers, counter = 0) => {
    try {
      const response = await kioskApi({
        method: "PUT",
        url: `${url}`,
        data,
        headers: {
          ...headers,
        },
      });

      return response.data;
    } catch (error) {
      let apiResponse = await handleResponse(
        error.response,
        callApi.put,
        url,
        data,
        headers,
        counter
      );

      return apiResponse;
    }
  },
  delete: async (url, data, headers, counter = 0) => {
    try {
      const response = await kioskApi({
        method: "DELETE",
        url: `${url}`,
        data,
        headers: {
          ...headers,
        },
      });

      return response.data;
    } catch (error) {
      let apiResponse = await handleResponse(
        error.response,
        callApi.delete,
        url,
        data,
        headers,
        counter
      );

      return apiResponse;
    }
  },
  getS3: async (url, params, counter = 0) => {
    void 0 === params && (params = {});

    let apiResponse = {};

    let reqURL = Object.keys(params).reduce(
      (acc, curr) => `${acc}${curr}=${encodeURIComponent(params[curr])}&`,
      url
    );

    try {
      const requestOptions = {
        method: "GET",
      };

      apiResponse = await fetch(reqURL, requestOptions);

      return apiResponse;
    } catch (e) {
      console.log("ERROR in fetching request => ", e);
      throw Error;
    }
  },
};

export const handleResponse = async (
  response,
  callback,
  url,
  data,
  headers,
  counter = 0
) => {
  if (counter > 1) {
    window.location.href = `${window.location.origin}/signup`;
    return;
  }
  if (response.data.status === 498 || response.data.status === 401) {
    let refreshResponse = await handleToken();
    if (refreshResponse) {
      const callbackResponse = await callback(url, data, headers, counter + 1);
      if (callbackResponse) {
        return callbackResponse;
      }
    }
  } else {
    return response.data;
  }
};

export const handleToken = async () => {
  //referCookieDirectly

  if (isLoggedIn()) {
    const success = await callTokenApi.refresh();
    if (success) {
      return success;
    } else {
      //insertAlertHere
      //youhavebeenloggedout
      //referCookieDirectly

      deleteAllCookies();
      const guestSuccess = await callTokenApi.guest();
      if (guestSuccess) {
        return guestSuccess;
      } else {
        //insertAlertHere
        //guestApiFail
      }
    }
  } else {
    const success = await callTokenApi.guest();
    if (success) {
      return success;
    } else {
      //insertAlertHere
      //guestApiFail
    }
  }
  return true;
};

export const callTokenApi = {
  guest: async () => {
    try {
      const response = await kioskApi({
        method: "GET",
        url: apiList.login.guest,
      });

      const { data } = response;
      return data.status === 200;
    } catch (error) {
      return false;
    }
  },
  refresh: async () => {
    try {
      const response = await kioskApi({
        method: "PUT",
        url: apiList.login.refresh,
      });
      const { data } = response;
      return data.status === 200;
    } catch (error) {
      return false;
    }
  },
};
